var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 4C8.71217 4 8.91566 4.08429 9.06569 4.23431C9.21571 4.38434 9.3 4.58783 9.3 4.8V7.2H11.7C11.9122 7.2 12.1157 7.28429 12.2657 7.43431C12.4157 7.58434 12.5 7.78783 12.5 8C12.5 8.21217 12.4157 8.41566 12.2657 8.56569C12.1157 8.71571 11.9122 8.8 11.7 8.8H9.3V11.2C9.3 11.4122 9.21571 11.6157 9.06569 11.7657C8.91566 11.9157 8.71217 12 8.5 12C8.28783 12 8.08434 11.9157 7.93431 11.7657C7.78429 11.6157 7.7 11.4122 7.7 11.2V8.8H5.3C5.08783 8.8 4.88434 8.71571 4.73431 8.56569C4.58429 8.41566 4.5 8.21217 4.5 8C4.5 7.78783 4.58429 7.58434 4.73431 7.43431C4.88434 7.28429 5.08783 7.2 5.3 7.2H7.7V4.8C7.7 4.58783 7.78429 4.38434 7.93431 4.23431C8.08434 4.08429 8.28783 4 8.5 4V4Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.f807cc7cdeb3e6b55e3c0352942d4dcd.svg";
export { ForwardRef as ReactComponent };